import { useCallback } from "react";
import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { SocialNetworkProfileServices } from "@/services/bedrock/SocialNetworkProfileServices";

function reviewQueryKey(userId: string | number, socialIdentityId: string | number) {
  return ["socialProfileReviews", userId, socialIdentityId] as const;
}

export const useClearSocialProfileReviewsCache = (userId: string | number, socialIdentityId: string | number) => {
  const queryClient = useQueryClient();

  return useCallback(
    () => queryClient.invalidateQueries({ queryKey: reviewQueryKey(userId, socialIdentityId) }).catch(console.error),
    [queryClient, userId, socialIdentityId]
  );
};

export const useSocialProfileReviews = (
  userId: string | number,
  socialIdentityId: string | number,
  enabled: boolean
) => {
  const clearSocialProfileReviewsCache = useClearSocialProfileReviewsCache(userId, socialIdentityId);

  const query = useInfiniteQuery({
    queryKey: reviewQueryKey(userId, socialIdentityId),
    queryFn: ({ pageParam }) => SocialNetworkProfileServices.getReviews(userId, socialIdentityId, pageParam, 20),
    initialPageParam: 1,
    getNextPageParam: lastPage => {
      const { page, totalPages } = lastPage.pagination;
      return (page ?? 0) < (totalPages ?? 0) ? (page ?? 0) + 1 : undefined;
    },
    enabled,
  });

  return { ...query, clearSocialProfileReviewsCache };
};
